// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__22r5m","vLegacy":"SelectSecondary_vLegacy__2JUZM","error":"SelectSecondary_error__3Sbpo","disabled":"SelectSecondary_disabled__3MeTJ"};